import React from "react";
import styles from "./EngagementMetrices.module.scss";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { engagementMetricesByPostTableData, engagementMetricesFirstTableData } from "../../../../../views/AdminPortal/dummyData";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";

const EngagementMetrices = () => {
    const firstTableColumns = [
        {
            name: "Platform",
            selector: (row) => row.platform,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Total Inquiries",
            selector: (row) => row.inquiries,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Average Response Time",
            selector: (row) => row.avgResponseTime,
            center: "true",
            minWidth: "240px",
        },
        {
            name: "Response Rate",
            selector: (row) => row.responseRate,
            center: "true",
            minWidth: "180px",
        },
    ];

    const options = [
        { label: "View details" },
        { label: "Edit" },
        { label: "Delete" },
        { label: "Quick change" },
    ];

    const engagementMetricesColumns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Post ID",
            selector: (row) => row.postId,
            center: "true",
        },
        {
            name: "Platform",
            selector: (row) => row.platform,
            center: "true",
        },
        {
            name: "Date Posted",
            selector: (row) => row.datePosted,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "Content Preview",
            selector: (row) => row.contentPreview,
            center: "true",
            width: "180px",
        },
        {
            name: "Likes",
            selector: (row) => row.likes,
            center: "true",
        },
        {
            name: "Comments",
            selector: (row) => row.comments,
            center: "true",
        },
        {
            name: "Shares",
            selector: (row) => row.shares,
            center: "true",
        },
        {
            name: "Engagement Rate",
            selector: (row) => row.engagementRate,
            center: "true",
            width: "180px",
        },
        {
            name: "Action",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.engagementMetricesContainer}>
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={engagementMetricesFirstTableData}
                    columns={firstTableColumns}
                    type="grayShadow"
                    highlightOnHover
                    responsive
                />
            </div>

            <div className={styles.filterTableWrapper}>
                <h5 className={styles.sectionHeading}>Engagement Metrics by Post</h5>
                <DynamicTableFilters
                    componentName={"Engagement Metrics by Post"}
                    onApply={handleApply}
                    onClear={handleClear}
                />
                <div className={styles.engagementMetricesTableWrapper}>
                    <DynamicDatatable
                        data={engagementMetricesByPostTableData}
                        columns={engagementMetricesColumns}
                        type="gray"
                        pagination
                        highlightOnHover
                        responsive
                    />
                </div>
            </div>
        </div>
    );
};

export default EngagementMetrices;